<template>
  <i-box>
    <span slot="title">
      <h3>{{ title }}</h3>
    </span>
    <span slot="heading">Shows the proportion of profiles active across two channels.</span>
    <span slot="content">
      <div v-loading="loading" element-loading-text="Loading Cross Platform Engagement...">
        <div v-if="engagements.length && !loading" class="cross-engagement-profiles">
          <cross-profile-table style="margin: 8px 0;" :profilesData="data"></cross-profile-table>
        </div>
        <div v-else style="height: 525px">
          <small class="graph-empty">No Data Loaded</small>
        </div>
      </div>
    </span>
  </i-box>
</template>

<script>
import IBox from '@/components/common/IBox';
import SocialIcon from '@/components/common/Icons/SocialIcon';
import CrossPlatformEngagementCellBlock from '@/components/profiles/charts/CrossPlatformEngagementCellBlock';
import CrossProfileTable from '@/components/profiles/charts/CrossProfileTable';

export default {
  name: 'CrossPlatformEngagement',
  props: {
    data: {
      type: Object,
      required: () => ({}),
    },
    title: {
      type: String,
      default: () => 'Cross Platform Engagement',
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    CrossPlatformEngagementCellBlock,
    CrossProfileTable,
    SocialIcon,
    IBox,
  },
  computed: {
    engagements() {
      return Object.keys(this.data).sort();
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-cross-platform-engagement {
  margin: 20px 0;
  .col-md-6 {
    margin: 20px 0;
  }
}
.cross-legend {
  margin-top: 20px;
}

.graph-empty {
  display: block;
  padding: 220px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// CrossPlatformEngagement.vue?55107746